import { LocaleMessages } from 'vue-i18n';
import core from '@/lang/de-DE/core';
import wallbox from '@/lang/de-DE/wallbox';
import assistant from '~/lang/de-DE/assistant';
import { mergeDeep } from '@/lang/merge-deep';

export default { de: mergeDeep(core, wallbox, assistant) } as LocaleMessages;
